<div class="components-summary-content">
  <p-card>
    <ng-template pTemplate="header">
      <span class="p-card-title">White Wood Components</span>
      <span>
        <p-toggleButton [formControl]="showZeroRows" offLabel="Show All Rows" onLabel="Hide Rows"></p-toggleButton>
      </span>
    </ng-template>
    <div *ngIf="loading" class="centered">
      <i class="pi pi-spin pi-spinner"></i>
      Calculating...
    </div>
    <p-table *ngIf="componentsSummary"
      [value]="filteredRows | async"
      styleClass="scrolltable"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template pTemplate="header">
        <tr>
            <th>Component Type</th>
            <th>Beginning Inventory</th>
            <th>Received</th>
            <th>Transferred</th>
            <th>Ending Inventory</th>
            <th>Usage</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
            <td>{{ (getProduct(row.productId) | async) || '&lt;unknown&gt;' }}</td>
            <td>{{ row.startingInventory }}</td>
            <td>{{ row.receivedUnits }}</td>
            <td>{{ row.transferredUnits }}</td>
            <td>{{ row.endingInventory }}</td>
            <td [class.positive]="row.usage > 0"
                [class.negative]="row.usage < 0">{{ row.usage }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="totals">
          <td>Totals</td>
          <td>{{ sumTotal('startingInventory') }}</td>
          <td>{{ sumTotal('receivedUnits') }}</td>
          <td>{{ sumTotal('transferredUnits') }}</td>
          <td>{{ sumTotal('endingInventory') }}</td>
          <td>{{ sumTotal('usage') }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
